'use strict';

import HeaderListPopup from 'views/listing/HeaderListPopup';
import EventUtils from 'utils/EventUtils';
import Server from 'server/Server';

import { SAIView } from '../../Additions';
import { FilterPopupView } from '../tasks/navigators/simple/FilterPopupView';
import { DomainContext } from '../../parametrage/DomainContext';
import { Filter } from '../../parametrage/structures/Filter';
import { Table } from '../../parametrage/structures/Table';
import { GridView } from '../../parametrage/structures/GridView';
import CClientConfiguration from 'parametrage/CClientConfiguration';
import { DataField } from '../../parametrage/structures/DataField';
import { Task } from '../../parametrage/structures/Task';
import ScriptUtils from 'utils/ScriptUtils';
import StringUtils from 'utils/StringUtils';
import GetGridDataRequest from '../../server/protocol/request/task/GetGridData';
import Context from '../../models/context/Context';
import CriteriaChoicePopup from './CriteriaChoicePopup';
import App from 'App';
import ColorUtils from 'utils/ColorUtils';
import { FilterCriteriaStore } from 'utils/FilterCriteriaStore';
let $ = require('jquery');
let _ = require('lodash');
const moment = require('moment');

/**
 * A criteria that the user is allowed to pick from a grid. Such a criteria is declared
 * in the parametrage by an Elem of the filter carrying a GridView attribute.
 */
interface SelectableCriteria {
    datafieldId: string;
    gridView: string;
    filterName: string;
    datafield: DataField;
}

class SearchBar extends SAIView {
    //Title of the popup asking which criteria the user wants to set, in line with the other
    //popups of the client which carry their title in French
    private static readonly CRITERIA_CHOICE_TITLE = 'Choix du critère';

    //Column ids that may hold the human readable value of a picked row, by order of preference
    private static readonly LABEL_COLUMN_IDS = ['DLABEL', 'LABEL', 'LIBELLE'];

    private filterPopup: FilterPopupView;
    private filterValues: Array<any>;
    private domainContext: DomainContext;
    private searchBar: JQuery<HTMLElement>;
    private filterHolder: JQuery<HTMLElement>;
    private criteriasEnabled: boolean;
    private previousVal: string;
    private initialFilterValues: any;
    protected scriptContext: any;
    private hideCriterias: boolean;
    private selectableCriterias: Array<SelectableCriteria>;
    private disabledCriterias: Array<string>;

    constructor(options) {
        super(options);
        this.template = require('templates/filter/SearchBar.ejs');
        this.options = options;

        this.domainContext = options.domainContext;
        this.criteriasEnabled = options.enabled;
        this.filterValues = [];
        this.initialFilterValues = {};
        this.hideCriterias = options.hideCriterias ? options.hideCriterias : false;
        this.selectableCriterias = [];
        this.disabledCriterias = [];

        for(let filter in this.options.filters) {
            let filterElement = this.options.filters[filter];
            this.initialFilterValues[filterElement.datafieldId] = filterElement.value;
        }

        this.scriptContext = {
            '$CURRENT_CHAIN': options.taskId.substring(0,3),
            '$LOCAL_DATE': moment().format('YYYY-MM-DD 00:00:00'),
            '$LOCAL_DATETIME': moment().format('YYYY-MM-DD HH:mm:ss'),
        };
    }

    public render(): any {
        SearchBar.declareAccentColors();
        this.$el.html(this.template({
            enabled : this.options.enabled,
            hideCriterias: this.hideCriterias
        }));
        this.searchBar = this.$el.find('.searchBar');
        this.searchBar.on('change', this.onSearchChange.bind(this));

        this.filterHolder = this.$el.find('.criterias-filter');
        for(var key in this.filterValues){
            if(this.filterValues[key].html){
                this.appendFilterEntry(this.filterValues[key]);
            }
        }

        this.refreshCriteriasButton();
    }

    public initializeFilter(gridConfig: GridView, tableConfig: Table, filterConfig: Filter, taskConfig : Task): Promise<void> {
        let me = this;
        return new Promise((accept, reject) => {
            if(!me.filterPopup) {
                me.filterPopup = new FilterPopupView({
                    gridConfig: gridConfig,
                    tableConfig: tableConfig,
                    filterConfig: filterConfig
                });

                let filterElements = filterConfig.getElements();
                let datafieldsMap = {};
                let allFetch = [];
                for(let key in filterElements) {
                    let curEl = filterElements[key];
                    allFetch.push(CClientConfiguration.getDataField(curEl.getDatafieldId(), me.domainContext, taskConfig));
                }
                Promise.all(allFetch)
                    .then((datafields: Array<DataField>) => {
                        for(let key in datafields) {
                            let df = datafields[key];
                            datafieldsMap[df.getId()] = df;
                        }
                        for(let key in filterElements) {
                            let curEl = filterElements[key];
                            let permanentValue = curEl.getPermanentValue();
                            let defaultValue = curEl.getDefaultValue();
                            let datafield = datafieldsMap[curEl.getDatafieldId()];
                            if(datafield !== undefined) {
                                let current = {
                                    text: datafield.getLabel(),
                                    renderingId: Math.floor(Math.random() * 10000000),
                                    value: permanentValue ? permanentValue : defaultValue,
                                    datafieldId: datafield.getId()
                                }
                                this.addNewFilterEntry(current, curEl.mustBeShownOnNavigator(), curEl.mustBeShownOnNavigator() ? 'boolean' : undefined);

                                //A criteria carrying a grid view in the parametrage can be picked by the user
                                if(curEl.getAttribute('gridView') !== undefined) {
                                    this.selectableCriterias.push({
                                        datafieldId: datafield.getId(),
                                        gridView: curEl.getAttribute('gridView'),
                                        filterName: curEl.getAttribute('filter') !== undefined ? curEl.getAttribute('filter') : datafield.getFilterName(),
                                        datafield: datafield
                                    });
                                }
                            } else {
                                console.warn('Datafield ' + curEl.getDatafieldId() + ' hasn\'t been found in the table, thus it\'s discarded');
                            }
                        }
                        me.mergeFilters();
                        me.restorePersistedCriterias();
                        me.refreshCriteriasButton();
                        accept();
                    })
                    .catch(reject);
            } else {
                accept();
            }
        });
    }

    mergeFilters() : void {
        var initialUsed = [];

        for(let index in this.filterValues) {
            let item = this.filterValues[index];
            let premergeValue = item.value;
            if(this.initialFilterValues[item.datafieldId]) {
                initialUsed.push(item.datafieldId);
                item.value = this.initialFilterValues[item.datafieldId];
            }

            item.value = ScriptUtils.handleDateTransformation(item.value, 'YYYY-MM-DD 00:00:00');
            if(item.value !== premergeValue) {
                this.updateFilterLabel(item);
            }
        }
        if(this.initialFilterValues) {
            for(let index in this.initialFilterValues) {
                var initialItemValue = this.initialFilterValues[index];
                if (initialItemValue.indexOf(index) < 0) {
                    //The filter didn't contain the entry so it hasn't been applied yet
                    var newItem = {
                        datafieldId: index,
                        value: initialItemValue
                    };
                    this.filterValues.push(newItem);
                }
            }
        }
        this.resizeContainer();
    }

    private resizeContainer():void {
        let criterias = this.$el.find('.criterias-filter');
        let criteriaItems = criterias.children();
        if(criteriaItems.length > 0) {
            let firstCriteriaTop = criteriaItems[0].offsetTop;
            let firstCriteriaHeight = criteriaItems[0].clientHeight;
            let lastCriteriaTop = criteriaItems[criteriaItems.length-1].offsetTop;
            let dataContainer = this.$el.parent().find('.data-container-content');
            dataContainer.height(dataContainer.height() - (lastCriteriaTop - firstCriteriaTop) - firstCriteriaHeight);
        }
    }

    appendFilterEntry(entry){
        if(entry.value !== undefined && entry.value !== '') {
            this.filterHolder.append(entry.html);
            //A selectable criteria can only hold one value at a time, the button
            //is thus disabled as long as every criteria is used
            this.refreshCriteriasButton();
        }
    }

    /**
     * Refreshes the state of the button that allows to add a criteria. Adding a criteria
     * requires a selectable criteria declared in the filter of the parametrage (an Elem
     * carrying a GridView) that is not used yet, and the server must not have disabled the
     * criterias for the current user.
     */
    private refreshCriteriasButton(): void {
        let button = this.$el.find('.addFilter');
        button.off('click');
        if(this.getEnabledCriterias().length > 0) {
            button.removeClass('disabled-filter');
            button.on('click', this.onFilterBtnClicked.bind(this));
        } else {
            button.addClass('disabled-filter');
        }
    }

    /**
     * Allows the server to hide some criterias for the current user. This is used when the
     * availability of a criteria is a business matter that the client cannot resolve by
     * itself : a group criteria only makes sense for a tablet handling several groups for
     * exemple.
     *
     * @param disabled The datafields of the criterias to hide. An empty list restores every
     * declared criteria, the legacy boolean values hide all of them.
     */
    public setDisabledCriterias(disabled: Array<string>): void {
        if(this.disabledCriterias.join(',') !== disabled.join(',')) {
            this.disabledCriterias = disabled;
            this.refreshCriteriasButton();
        }
    }

    /**
     * @returns The first selectable criteria that has no value yet, undefined if all the
     * declared criterias are already used
     */
    private getEnabledCriterias(): Array<SelectableCriteria> {
        if(this.disabledCriterias.indexOf('*') >= 0) {
            return [];
        }

        return this.selectableCriterias.filter((criteria) => {
            return this.disabledCriterias.indexOf(criteria.datafieldId) < 0;
        });
    }

    /**
     * Exposes the color of the application theme to the style sheets, so that the criterias
     * and their selectors are highlighted with it rather than with a hard coded color. The
     * soft variant tints the background of a selected entry.
     */
    private static declareAccentColors(): void {
        let root = document.documentElement;
        if(root.style.getPropertyValue('--criteria-accent') !== '') {
            return;
        }

        let theme = App.getConfig().appTheme;
        let rgb = ColorUtils.hexToRgb(theme);
        root.style.setProperty('--criteria-accent', theme);
        if(rgb) {
            root.style.setProperty('--criteria-accent-soft', 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.12)');
        }
    }

    /**
     * @param datafieldId The datafield of a criteria
     * @returns The human readable value currently held by that criteria, undefined when it
     * has none
     */
    private getCriteriaLabel(datafieldId: string): string {
        let entry = this.filterValues.find((current) => {
            return current.datafieldId === datafieldId && current.value !== undefined && current.value !== '';
        });

        return entry !== undefined ? entry.label : undefined;
    }

    /**
     * Returns the values of the selectable criterias that are currently applied. Those are
     * the criterias the user explicitly picked : they must follow every call made on behalf
     * of this navigator, a notification included, so that the whole screen works on the same
     * perimeter as the displayed list. A disabled criteria is ignored, even if it still holds
     * a value, as it no longer applies to the list.
     *
     * @returns The applied criterias, empty when the user picked none
     */
    public getSelectableCriteriaValues(): Array<{datafieldId: string, value: string}> {
        let values = [];
        for(let criteria of this.getEnabledCriterias()) {
            let entry = this.filterValues.find((current) => {
                return current.datafieldId === criteria.datafieldId && current.value !== undefined && current.value !== '';
            });
            if(entry !== undefined) {
                values.push({ datafieldId: criteria.datafieldId, value: entry.value });
            }
        }

        return values;
    }

    /**
     * @param datafieldId The datafield of a criteria
     * @returns The values currently held by that criteria, empty when it has none
     */
    private getCriteriaValues(datafieldId: string): Array<string> {
        let entry = this.filterValues.find((current) => {
            return current.datafieldId === datafieldId && current.value !== undefined && current.value !== '';
        });

        return entry !== undefined ? (entry.value + '').split(',') : [];
    }

    /**
     * @param datafieldId The datafield of a criteria
     * @returns The selectable criteria of the given datafield, undefined if the datafield
     * is not a selectable criteria
     */
    private getSelectableCriteria(datafieldId: string): SelectableCriteria {
        return this.selectableCriterias.find((criteria) => { return criteria.datafieldId === datafieldId; });
    }

    /**
     * Applies the given value on the given criteria. A criteria only holds one value at a
     * time, the previous one is thus discarded.
     * @param criteria The criteria to apply the value on
     * @param value The value of the criteria, as it will be sent to the server
     * @param label The human readable value, displayed to the user
     * @param persist true to remember the selection on this device
     */
    private applyCriteriaSelection(criteria: SelectableCriteria, value: string, label: string, persist: boolean): void {
        let previousEntries = this.filterValues.filter((entry) => { return entry.datafieldId === criteria.datafieldId; });
        previousEntries.forEach((entry) => {
            if(entry.html) { entry.html.remove(); }
            this.filterValues.splice(this.filterValues.indexOf(entry), 1);
        });

        this.addNewFilterEntry({
            value: value,
            text: criteria.datafield.getLabel() + ' : ' + label,
            renderingId: parseInt(Math.random()*100000000 + ''),
            datafieldId: criteria.datafieldId,
            label: label
        }, true);

        if(persist) {
            this.persistCriteria(criteria.datafieldId, value, label);
        }
    }

    /**
     * @returns The datafields of the criterias the user may pick in this search bar. A
     * listing built on this filter applies the stored value of each of them.
     */
    public getSelectableDatafields(): Array<string> {
        return this.selectableCriterias.map((criteria) => { return criteria.datafieldId; });
    }

    /**
     * Stores the selection of a criteria on this device so that it survives a restart of
     * the application, and is shared with every listing whose filter declares the same
     * criteria - including the ones of other tasks.
     */
    private persistCriteria(datafieldId: string, value: string, label: string): void {
        FilterCriteriaStore.store(this.domainContext.getId(), datafieldId, value, label);
    }

    /**
     * Restores the criterias that have been selected previously on this device.
     */
    private restorePersistedCriterias(): void {
        for(let key in this.selectableCriterias) {
            let criteria = this.selectableCriterias[key];
            let persisted = FilterCriteriaStore.get(this.domainContext.getId(), criteria.datafieldId);
            if(persisted !== undefined) {
                this.applyCriteriaSelection(criteria, persisted.value, persisted.label, false);
            }
        }
    }

    onSearchChange(){
        var val = this.searchBar.val() + '';

        if(this.previousVal !== val && (this.previousVal || val.length !== 1)){
            this.previousVal = val;
            var customized = this.isFilterCustomized();
            if(!customized){
                if(val){
                    customized = true;
                }
            }
            this.trigger('searchChanged', val, customized);
        }
    }

    isFilterCustomized(){
        return false;
        //TODO : compare with initial array
    }

    public getFilter(): {values: Array<{ datafieldId: string, value : any}>, text: string }{
        return {
            values : this.filterValues.map((entry) => { return {
                datafieldId: entry.datafieldId,
                value: StringUtils.resolveTextProperties(entry.value, this.scriptContext)
            };
            }),
            text : this.previousVal
        };
    }

    onFilterBtnClicked(evt) {
        let enabled = this.getEnabledCriterias();
        if(enabled.length === 0) {
            //The button should have been disabled, nothing can be selected
            return;
        }

        /*
         * With a single criteria the choice is already made, going through a popup would only
         * add a click. With several, the user must say which one he means: picking one that
         * already holds a value is how he changes it, without removing it first.
         */
        if(enabled.length === 1) {
            this.openCriteriaValues(enabled[0]);
            return;
        }

        let choicePopup = new CriteriaChoicePopup({
            title: SearchBar.CRITERIA_CHOICE_TITLE,
            criterias: enabled.map((criteria) => {
                return { datafieldId: criteria.datafieldId, label: criteria.datafield.getLabel(), value: this.getCriteriaLabel(criteria.datafieldId) };
            })
        });
        this.listenToOnce(choicePopup, 'criteriaSelected', (datafieldId) => {
            choicePopup.hide();
            this.openCriteriaValues(this.getSelectableCriteria(datafieldId));
        });
        choicePopup.display();
    }

    /**
     * Opens the selector of a criteria. Several values may be picked, and the ones already
     * applied are pre-selected so that the popup shows the current state rather than a blank
     * list. The whole selection replaces the previous one.
     *
     * @param criteria The criteria whose values are being chosen
     */
    private openCriteriaValues(criteria: SelectableCriteria): void {
        let me = this;
        this.getFilterGridConfig(criteria)
            .then(([gridConfig, tableConfig]) => {
                let iconConfig = undefined;
                if(gridConfig || tableConfig) {
                    iconConfig = Object.assign({}, gridConfig, tableConfig);
                }
                let newHeaderPop = new HeaderListPopup({
                    taskId: this.options.taskId,
                    gridId: criteria.gridView,
                    filterId: criteria.filterName,
                    title: criteria.datafield.getLabel(),
                    domainContext: this.domainContext,
                    iconConfig: iconConfig,
                    //The values of a criteria are a short list: a search field would only
                    //take room, and the dedicated style highlights the checked values
                    showSearchbar: false,
                    extraClass: 'criteria-selection',
                    multiSelect: true,
                    initialSelection: this.getCriteriaValues(criteria.datafieldId)
                });
                this.listenToOnce(newHeaderPop, 'selection', function(selection){
                    //Unchecking every value means the user no longer wants the criteria: it is
                    //removed, rather than kept as an empty chip that restricts nothing
                    if(selection === undefined || selection === '') {
                        let current = me.filterValues.find((entry) => { return entry.datafieldId === criteria.datafieldId; });
                        if(current !== undefined) { me.onDeleteFilterClick(current.renderingId); }
                        return;
                    }

                    let listing = newHeaderPop.getHeaderList().getListing();
                    let labels = (selection + '').split(',').filter((value) => { return value !== ''; }).map((value) => {
                        let row = listing.getRow('ID', value);
                        return SearchBar.resolveDisplayLabel(row !== undefined ? row.getColumnsValues() : {}, value);
                    });
                    me.applyCriteriaSelection(criteria, selection, labels.join(', '), true);
                    me.refreshData();
                });
                newHeaderPop.display();
            });
    }

    /**
     * Retrieves the label to display for a value picked in a grid. The column holding the
     * human readable value is a convention of the parametrage : the usual identifiers are
     * tried in turn, and the raw value is displayed when none of them is present.
     *
     * @param columns The columns of the picked row, as returned by getColumnsValues()
     * @param value The raw value of the criteria
     * @returns The label to display next to the name of the criteria
     */
    private static resolveDisplayLabel(columns: {[columnId: string]: any}, value: string): string {
        if(columns !== undefined) {
            for(let columnId of SearchBar.LABEL_COLUMN_IDS) {
                if(columns[columnId] !== undefined && columns[columnId].value !== undefined && columns[columnId].value !== '') {
                    return columns[columnId].value;
                }
            }
        }

        return value;
    }

    getFilterGridConfig(criteria: SelectableCriteria) : Promise<any>{
        //A missing icon configuration must not prevent the selection from being displayed
        let iconConfigPromise = [
            CClientConfiguration.getGridIconConfig(criteria.gridView, this.options.taskId, this.domainContext).catch(() => undefined),
            CClientConfiguration.getTableIconConfig(criteria.datafield.getTableName(), this.options.taskId, this.domainContext).catch(() => undefined)
        ];
        return Promise.all(iconConfigPromise);
    }

    onFilterPopupButtonClicked(evt) {
        var action = EventUtils.getAttributeValue(evt, 'role');
        if (action === 'ok') {
            //record validation. We get the values and send the modify on server
            var recordValues = this.filterPopup.getSelection();

            if(!this.filterValues){
                this.filterValues = [];
            }

            var currentEntry;
            let newEntryId = parseInt(Math.random()*100000000 + '');
            currentEntry = {
                value : this.buildFilterValue(recordValues),
                text : this.filterPopup.getDfText(recordValues.dfId) + ' ' + this.filterPopup.getChoiceText(recordValues.operation) + ' ' + recordValues.value,
                type : recordValues.type,
                renderingId : newEntryId
            };
            this.addNewFilterEntry(currentEntry, true);

            this.refreshData();
        }
    }

    refreshData(){
        this.trigger('searchChanged');
    }

    addNewFilterEntry(entry, render:boolean, type?){
        if(!type) { type = 'text'; }
        this.filterValues.push(entry);
        var visual = $('<div class="filterCriteria" data-index="'+entry.renderingId+'"></div>');
        //A value picked for a selectable criteria is displayed as a chip of the theme color
        if(entry.datafieldId !== undefined && this.selectableCriterias !== undefined && this.getSelectableCriteria(entry.datafieldId) !== undefined) {
            visual.addClass('criteriaChip');
        }
        if(type === 'text') {
            visual.append('<div class="text">'+entry.text+'</div>');
            var cross = $('<span class="glyphicon glyphicon-remove deleteBtn" aria-hidden="true"></span>');
            visual.append(cross);
            cross.click(this.onDeleteFilterClick.bind(this, entry.renderingId));
        } else {
            let visualEntry = $('<label>' + entry.text + '</label>')
            let checkbox = $('<input class="changeableField" type="checkbox" ' + (entry.value === true || entry.value === '1' ? 'checked' : '') + '>');
            visualEntry.prepend(checkbox);
            visual.append(visualEntry)
            checkbox.change(this.onCheckBoxFilterClick.bind(this, entry.renderingId, checkbox));
        }
        entry.html = visual;
        if(render){
            this.appendFilterEntry(entry);
        }
    }

    onDeleteFilterClick(existing){
        var index = _.findIndex(this.filterValues, function(item){ return item.renderingId === existing;});
        var current = this.filterValues[index];
        current.html.remove();
        this.filterValues.splice(index, 1);

        //A selectable criteria becomes available again and must not be restored on the next start.
        //The stored value must be dropped BEFORE the refresh: the outgoing request merges back the
        //criterias stored for the filter (see Listing.mergeStoredCriterias), so a value still held
        //by the storage would be reapplied and the criteria would not actually be removed.
        if(this.getSelectableCriteria(current.datafieldId) !== undefined) {
            this.persistCriteria(current.datafieldId, undefined, undefined);
        }

        this.refreshData();
        this.refreshCriteriasButton();
    }

    onCheckBoxFilterClick(filterId, checkbox){
        var index = _.findIndex(this.filterValues, function(item){ return item.renderingId === filterId;});
        var current = this.filterValues[index];
        current.value = checkbox.is(':checked');
        this.refreshData();
    }

    buildFilterValue(filterValues){
        var value;
        if(filterValues.type === 'text'){
            if(filterValues.operation === 'CONTAINS'){
                value = '*'+filterValues.value+'*';
            }else if(filterValues.operation === 'NOTCONTAINS'){
                value = 'NOT *'+filterValues.value+'*';
            }else if(filterValues.operation === 'STARTS'){
                value = filterValues.value+'*';
            }else if(filterValues.operation === 'ENDS'){
                value = '*'+filterValues.value;
            }else if(filterValues.operation === 'DOESNOTSTART'){
                value = 'NOT '+filterValues.value+'*';
            }else if(filterValues.operation === 'DOESNOTEND'){
                value = 'NOT *'+filterValues.value;
            }else if(filterValues.operation === 'ISONEOF'){
                //value = filterValues.value.replace('/\s*[ ,]\s*/g', ' OR '); // Supports 1000,2000 / 1000, 2000 / 1000 2000 / 1000 , 2000
            }
        }
        return value;
    }

    updateFilterLabel(entry) {
        let me = this;
        CClientConfiguration.getTask(this.options.taskId, this.domainContext)
            .then((task) => {
                CClientConfiguration.getDataField(entry.datafieldId, this.domainContext, task as Task)
                    .then((datafield) => {
                        let text = datafield.getLabel();
                        if(datafield.getFormat() === 'List') {
                            me.getItemLabel(entry.value, datafield)
                                .then((result) => {
                                    let columns = result.items.length > 0 ? result.items[0].columns : undefined;
                                    let label = SearchBar.resolveDisplayLabel(columns, entry.value);
                                    text =  datafield.getLabel() + ' : ' + label;
                                    entry.html.find('.text').html(text);
                                    // If the element is not in the DOM, add it
                                    if(!$.contains(document.documentElement,entry.html.get(0))) {
                                        me.appendFilterEntry(entry);
                                    }
                                });
                        } else {
                            text = datafield.getLabel() + ' : ' + entry.value;
                            entry.html.find('.text').html(text);
                            if(!$.contains(document.documentElement,entry.html.get(0))) {
                                me.appendFilterEntry(entry);
                            }
                        }
                    });
            });
    }

    // Perform a getGridData on the grid associated to the datafield with a filter
    getItemLabel(value : string, datafield: DataField) : Promise<any> {
        let dataRequest = new GetGridDataRequest(this.domainContext, this.options.taskId, datafield.getGridView());
        dataRequest.setFormatterId('');
        dataRequest.setFilterId('DEFAULT_FILTER');
        dataRequest.setRange(0, -1);

        // CRECHE : use this to bypass the filter on active children
        dataRequest.setSessionVars({
            'CUSTOMIZED_FILTER' : 'true'
        });

        return new Promise((accept, reject) => {
            // Get the grid configuration
            CClientConfiguration.getGridView(datafield.getGridView(), this.domainContext)
                .then((grid) => {
                    // The key is either defined in the foreignKeyField attribute of the datafield ...
                    let key = undefined;
                    if(datafield.getForeignKeyField()) {
                        key = grid.getColumn(datafield.getForeignKeyField()).getDatafieldId();
                    } else {
                        // ... or need to be guessed from the columns
                        key = this.getKeyFromGrid(grid);
                    }

                    if(key === undefined ) {
                        reject('Unable to find grid key');
                    }

                    let filterContext = new Context({contextId: 'filter'});
                    filterContext.addFields([{
                        datafieldId : key,
                        key : key,
                        value : value
                    }]);

                    dataRequest.setFilterContext(filterContext);

                    Server.performRequest(dataRequest)
                    .then((result) => {
                        accept(result);
                    });
                });
        });
    }

    // Return the first column ending with _PK
    getKeyFromGrid(grid : GridView) : string {
        let columns = grid.getColumns();
        for(let i in columns) {
            let column = columns[i];
            let datafieldName = column.getDataField().getId();
            let regex = /_PK$/;
            if(regex.test(datafieldName)) {
                return datafieldName;
            }
        }
        return undefined;
    }
}

export default SearchBar;
